import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmChatopsAndVideosToolsRoute: InvariantJiraRoute = {
	name: 'products-jsm-chatops-and-videos-tools',
	path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
	exact: true,
};
